import React from "react";
import { Button, UncontrolledTooltip } from "reactstrap";
import { DEMO_FEATURE_UNAVAILABLE, isDemoLocked } from "../utils/demoConfig";

const demoLockedControl = (tooltipId, control) => (
  <>
    <span id={tooltipId}>{control}</span>
    <UncontrolledTooltip placement="top" trigger="hover" target={tooltipId}>
      {DEMO_FEATURE_UNAVAILABLE}
    </UncontrolledTooltip>
  </>
);

const StatementPdfDownloadButton = ({ row, fileUrl, type = "details", onDownload }) => {
  const tooltipId = `statement-pdf-${type}-${row.id}`;
  const disabledButton = (
    <Button
      className="btn-status"
      color="primary"
      disabled
      style={{ pointerEvents: "none", maxWidth: "125px" }}
    >
      <b>Download</b>
    </Button>
  );

  if (isDemoLocked()) {
    return demoLockedControl(tooltipId, disabledButton);
  }

  if (fileUrl) {
    return (
      <a
        href={fileUrl}
        target="_blank"
        rel="noreferrer"
        onClick={() => {
          if (onDownload) {
            onDownload();
          }
        }}
      >
        <Button className="btn-status" color="primary" style={{ maxWidth: "125px" }}>
          <b>Download PDF</b>
        </Button>
      </a>
    );
  }

  return null;
};

export default StatementPdfDownloadButton;
